import { Box, Button, IconButton, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';
import ExoForm from '../exo/ExoForm';
import { NewOAuthEmailIntegration } from './NewOAuthEmailIntegration';
import { API_DELETE, DBRequest, DBUploadData, useConfig } from '../../api/api';
import { useState } from 'react';
import * as Yup from 'yup';

export const NewSignatureCertificate = ({
  onChange,
  userId,
  startData,
  onClose,
  debug,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  const fields = [
    {
      label: t('Add file'),
      key: 'file',
      type: 'directFileUpload',
      colspan: 3,
    },
    {
      label: t('E-Mail'),
      key: 'email',
      type: 'text',
      colspan: 3,
    },
    {
      label: t('Password'),
      key: 'password',
      type: 'password',
      colspan: 3,
    },
  ];

  function handleSubmit(data) {
    const formData = new FormData();

    const { file, email, password } = data;

    // Append the form fields to formData
    if (file) formData.append('file', file);
    if (email) formData.append('email', email);
    if (password) formData.append('password', password);

    // Append '_method' as PATCH if startData.id exists
    if (startData && startData.id) {
      formData.append('_method', 'PATCH');
    }

    // path for the API request
    const path =
      startData && startData.id
        ? `certificates/${startData.id}`
        : `certificates`;

    DBUploadData({
      config,
      path,
      formData: formData,
      onResponse: (res) => {
        // Handle the response if needed
        onChange(res);
        onClose();
      },
      onFeedback: handleFeedback,
      onLoading: setIsLoading,
    });
  }

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });
  function handleFeedback(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  const validationSchema = Yup.object().shape({
    file: Yup.string().required(t('Is required')),
  });

  const [defaultStartData] = useState(() => startData ?? { color: '#339e87' });

  return (
    <>
      <ExoForm
        debug={debug}
        header={t('Add Certificate')}
        className="grid grid-cols-3 gap-4"
        fields={fields}
        onSubmit={handleSubmit}
        startDataCollection={defaultStartData}
        size="small"
        validationSchema={validationSchema}
        noAutoReset
        noDifferences
        onCancel={onClose}
        isLoading={isLoading}
      />
    </>
  );
};
